import {getCurrentYear} from '../../utils/commons'
import TechGearReviewedLogo from './logo'
import {techGearReviewedStylesUS} from './styles'

const baseConfig = {
  domainName: 'techgearreviewed' as const,
  domainType: 'insider' as const,
  siteName: 'Tech Gear Reviewed',
  favicon: '/favicons/techgearreviewed.png',
}

const localeConfigs = {
  us: {
    measurementId: 'G-XERFCEX305',
    camelCaseUrl: 'TechGearReviewed.com',
    logo: <TechGearReviewedLogo className="size-14 shrink-0 tablet:size-11" />,
    title: (_category: string, count: string) =>
      `Top ${count} Electronics ${getCurrentYear()} in the US | TechGearReviewed.com – Expert Reviews & Smart Picks`,
    description: (_category?: string, _count?: string) =>
      `At TechGearReviewed.com, we review and compare the best electronics of ${getCurrentYear()} in the US. Discover expert insights, detailed comparisons, and top-rated gadgets to help you choose the right tech with confidence.`,
    styles: techGearReviewedStylesUS,
  },
}

export const createConfig = (locale: string = 'us') => {
  const localeConfig = localeConfigs[locale as keyof typeof localeConfigs] || localeConfigs.us
  return {
    ...baseConfig,
    ...localeConfig,
  }
}
